export default "__VITE_ASSET__Bv0_Lb6L__"